import { Provider } from "@angular/core";
import { CatchUpBillingActionHandler, LeakNotificationNotSentActionHandler, PendingPaymentPlanActionHandler, TylerSmartMeterActionHandler, UtilityServiceRequestActionHandler, } from "./aggregateActionHandlers";
import { AccountManagerService, AddAccountWizardService, AlertCodeService, ChargeFeeCodeService, CostCategoryCodeService, EntitySuggestService, FormCodeService, GroupCodeService, IssuedByCodeService, JobCodeService, MapService, MeterSearchService, MeterService, RateCodeService, ReadGroupService, ServiceAddressService, ServiceCodeService, ServiceOrderWizardApiService, StaffCodeService, TylerSmartMeterService, UBAccountLookupService, UBAccountService, UBDashboardService, UtilityBillingDialogService, } from "./services";
export function provideUtilityBilling(): Array<Provider>
{
    return [
        AccountManagerService,
        AddAccountWizardService,
        AlertCodeService,
        ChargeFeeCodeService,
        CostCategoryCodeService,
        EntitySuggestService,
        FormCodeService,
        GroupCodeService,
        IssuedByCodeService,
        JobCodeService,
        MapService,
        MeterSearchService,
        MeterService,
        RateCodeService,
        ReadGroupService,
        ServiceAddressService,
        ServiceCodeService,
        ServiceOrderWizardApiService,
        StaffCodeService,
        TylerSmartMeterService,
        UBAccountLookupService,
        UBAccountService,
        UBDashboardService,
        UtilityBillingDialogService,
        CatchUpBillingActionHandler,
        LeakNotificationNotSentActionHandler,
        PendingPaymentPlanActionHandler,
        TylerSmartMeterActionHandler,
        UtilityServiceRequestActionHandler,
    ];
}
